<template>
    <div class="input-group">
        <div class="input-group-prepend">
            <button class="input-group-text rounded-0" v-bind:class="locationClass" v-on:click="getMyLocation()">
                <svg width="15" height="22" viewBox="0 0 15 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5419 0C11.648 0 15 3.29588 15 7.41573C15 10.2172 9.30168 18.7865 7.5419 22C5.69832 18.7865 0 10.2172 0 7.41573C0 3.29588 3.35196 0 7.5419 0ZM7.5419 3.70787C9.30168 3.70787 10.8101 5.10861 10.8101 6.92135C10.8101 8.73408 9.30168 10.1348 7.5419 10.1348C5.69832 10.1348 4.18994 8.73408 4.18994 6.92135C4.18994 5.10861 5.69832 3.70787 7.5419 3.70787Z" :fill="`#${iconColor}`"/>
                </svg>
            </button>
        </div>
        <b-form-select v-model="internalValue" :options="locations" value-field="id" text-field="name" class="rounded-0 agile-select">
            <b-form-select-option :value=0 disabled >{{ label }}</b-form-select-option>
        </b-form-select>    
    </div>
</template>

<script>
export default {
    name: "LocationControl",
    props: ["active", "value", "label", "locations"],
    data() {
        return {
            id:0,
            name:'Dima',
        };
    },
    methods:{
        getMyLocation() {
                console.log('Set my location again')
                this.$emit("update-location", 0);
            },
    },
    computed: {
        locationClass: function() {
            return this.active ? ["bg-agile-black"] : ["bg-white"];
        },
        
        internalValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("update-location", newValue);
            },
            
        },

        iconColor: function() {
            return this.active ? 'F8F8F8' : '202020';
        }
    },
};
</script>

<style lang="scss" scoped>
    .custom-select{
        background: url('../assets/icon/drop-down-icon.svg') no-repeat right;
        border: 1px solid rgba(32, 32, 32, 0.5);
        border-left: 0;
    }
    .input-group-text{
        border: 1px solid rgba(32, 32, 32, 0.5);
        border-right: 0;
    }
    .agile-select{
        font-family: 'gilroy';
        font-weight: 500;
        font-size: 14px;
    }
</style>
